<template>
  <div>
	<!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Assign Modules</strong>
          </CCardHeader>
          <CCardBody>
			<CForm class="formData">
            <CRow>
				<CCol sm="12">
                <!-- <CInput
                  label="Assign Modules to Role"
                  placeholder="Role Name"
                  name="RoleName"
                  id="RoleName"
                /> -->
					<label class="m-0 col-fonts-black">Select Role</label>
				</CCol>
				<CCol sm="12" class="mb-3">
				<!-- {{roleOptions[0].RoleName}} -->
				<!-- <div v-for="role in roleOptions">{{role.RoleName}}</div> -->
					<select class="v-select" id="rollselect">
						<option  v-for="role in roleOptions" :value="role.Role_Id" @input="roleSel" >{{role.RoleName}}</option> 
					</select>
              	<!-- <v-select :options="roleOptions"  placeholder="Select Role" @input="roleSel"></v-select> -->
              </CCol>
            </CRow>

			<CRow>
				<CCol sm="12" class="mb-2">
					<label class="m-0 col-fonts-black">Select Module</label>
				</CCol>
				<CCol sm="12" class="mb-3 d-flex p-0 flex-wrap">
					<CCol col="4" v-for="(mod, index) in modulesArr" :key="index">
						<div class="form-check form-check-inline" >
							<input class="form-check-input module-check modulecheck" type="checkbox" :id="'inlineCheckbox1'+index" :value="mod.Module_Id">
							<label class="form-check-label" :for="'inlineCheckbox1'+index">{{mod.ModuleName}}</label>
						</div>
					</CCol>
				</CCol>
			</CRow>


            <!-- <CRow>
                <template v-for="(name, key) in checkboxNames">
                <CRow sm="12" form class="form-group" :key="name">
                  <CCol tag="label" sm="3" class="col-form-label">
                    {{name}}
                  </CCol>
				  <CCol sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <CInputCheckbox
                      v-for="(option, optionIndex) in options"
                      :key="key + option"
                      :label="option"
                      :value="option"
                      :custom="key > 1"
                      :name="`Option 1${key}`"
					  :class="check"
                    />
                  </CCol>
                   <CCol sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <CInputCheckbox
                      v-for="(option, optionIndex) in options"
                      :key="key + option"
                      :label="option"
                      :value="option"
                      :custom="key > 1"
                      :name="`Option 1${key}`"
                      :checked="optionIndex === key"
                      :inline="key % 2 === 1"
                    />
                  </CCol> 
                </CRow>
              </template>
            </CRow> -->
           
            <CRow	>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Add</button>
			</CCol>
			 
            </CRow>
			</CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Assign_module',
  data () {
    return {
	  	roleOptions : [],
		//   formCollapsed: true,
		//   checkboxNames: ['Change Status'],
		//   options: ['role-list', 'role-create', 'role-edit', 'role-delete', 'deshboard-transactions-chart'],     
		modulesArr: [],
		roleArr: [],
		// Roleselect:'',
		// roleSel:'',
		Role_Id: '',
		isLoading: false,
  	}
  },
  mounted () {
	this.isLoading = true;
	var token=localStorage.getItem("auth");
	var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
	var self = this;
		var requestInfo = {	
			Token:token,
			Session_User_Id:Session_User_Id,
		};
		//console.log(requestInfo);
		var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'ManageRole/GetRolesList',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		axios(config)
		.then((result) => {
			this.isLoading = false;			
			if(result.data.status_code==200){
				var obj=result.data.response;
				// //console.log(obj)
				// var roleOptionsArr=obj;		

				// self.roleArr=obj;		
				// var roleSingleArr=[];
				// var roleArr = roleOptionsArr.find(function(jsonitem, i){
				// 	//console.log(jsonitem.Plant_Name)
				// 	roleSingleArr.push(jsonitem.Role_Id);
				// 	roleSingleArr.push(jsonitem.RoleName);				
				// });
				self.roleOptions=obj;	
				// console.log(self.roleOptions);

			}else{				
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
	})
	this.isLoading = true;
	var self1 = self;
	var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'ManageModule/GetModuleList',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
	axios(config)
		.then((result) => {		
			this.isLoading = false;
			if(result.data.status_code==200){
				var obj=result.data.response;
				//console.log(obj)
				// var modulecheckArr=obj;		
				self1.modulesArr=obj;	
				// console.log(obj);

			}else{				
				self1.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
	})

	.catch((error) => {
		this.isLoading = false;
		//var errorObject=JSON.stringify(error.response.data.errors);			
		//console.log(errorObject);		   
		this.$swal.fire({
			icon: 'error',
			title: 'Oops...',
			text: 'Something went wrong!'		 
		})
    });
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){		
		this.$router.push({path:'Manage_assign_module'})
	},
	roleSel(value) {
		// var selectedrole='';
		// selectedrole=this.Role_Id=value;
		// this.Roleselect=value;	
		// console.log(Roleselect);

		// var token=localStorage.getItem("auth");
		// var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		// var self = this;
		
		// var requestInfo = {	
		// 	Token:token,
		// 	Session_User_Id:Session_User_Id,
		// };
		
		// //console.log(requestInfo);
		// var data = JSON.stringify(requestInfo);							
		// 	var config = {
		// 	  method: 'post',
		// 	  url: apiURL+'ManageRole/GetRolesList',
		// 	  headers: { 
		// 		'Content-Type': 'application/json'
		// 	  },
		// 	  data : data
		// };
		// axios(config)
		// .then(function (result) {			
		// 	if(result.data.status_code==200){
		// 		var obj=result.data.response;
		// 		//console.log(obj)
		// 		var roleOptionsArr=obj;		

		// 		self.roleArr=obj;		
		// 		var roleSingleArr=[];
		// 		var roleArr = roleOptionsArr.find(function(jsonitem, i){
		// 			//console.log(jsonitem.Plant_Name)
		// 			// roleSingleArr.push(jsonitem.Role_Id);
		// 			if(jsonitem.RoleName==value)	{
		// 				self.Role_Id=jsonitem.Role_Id;
		// 				roleSingleArr.push(self.Role_Id);
		// 				console.log(self.Role_Id);
		// 			}	
		// 		});		
		// 		self.itemsRoles=roleSingleArr;	

		// 	}else{				
		// 		self.$swal.fire({
		// 		  icon: 'error',
		// 		  title: 'Oops...',
		// 		  text: result.data.message		 
		// 		})
		// 	}
		// 	})

		// 	.catch(function (error) {
		// 		//var errorObject=JSON.stringify(error.response.data.errors);			
		// 		//console.log(errorObject);		   
		// 		self.$swal.fire({
		// 			icon: 'error',
		// 			title: 'Oops...',
		// 			text: 'Something went wrong!'		 
		// 		})
		// 	});
	
	},
	submit(){		
		this.isLoading = true;	
		// console.log(value)	
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var token=localStorage.getItem("auth");
		var Roleselect = $('#rollselect').val();
		// console.log(Roleselect);
		var checkArr= [];
		$('.modulecheck').each(function(){
			if($(this).is(":checked")){
				checkArr.push($(this).val());
			}
		});
		var module_ids = checkArr.join(",");
		// console.log(module_ids);



		// return false;
		var requestInfo = {
		  Token:token,
		  Session_User_Id:Session_User_Id,
		  Role_Id:Roleselect,
		  Module_Ids:module_ids,
		};		
		var self =this;
		// console.log(requestInfo);

		var data = JSON.stringify(requestInfo);					
			var config = {
			  method: 'post',
			  url: apiURL+'ManageModule/AssignModuleToRole',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		  };
      
		axios(config)
		.then((result) => {
			this.isLoading = false;	
			//console.log(config);	
			if(result.data.status_code==200){				
				this.$swal.fire(
					'Saved',
					result.data.message,
					'success'
				);
				$('.formData')[0].reset();
			}else{									
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		}).catch((error) => {					  
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	}
  }
}
</script>
